/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import StepNavItem from 'material/embeds/steps/stepnav/navitem/navitem_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/steps/stepnav/stepnav_styles';



/* ========== ~~~~~~~~~~ STEP NAV ~~~~~~~~~~ ========== */
const StepNav = (props) => {
    // Component doesn't display itself for non-step pages
    if(!props.stepQueueContent.includes(props.currentStepPage)) { return null; }
    return(
        props.currentStepPage ?
            <div className={`stepnav ${props.classes.stepnav} step-${props.currentStepPage}`}>
                <StepNavItem type={`previous`} handleSaveEmbed={props.handleSaveEmbed}/>
                <StepNavItem type={`next`} handleSaveEmbed={props.handleSaveEmbed} />
            </div>
        : null
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(StepNav);
